module.exports = __webpack_public_path__ + "static/media/traffic-severe.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/traffic-severe.svg
// module id = 826
// module chunks = 0